var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoRecommendation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.4 146.7H59.8501C48.1501 146.7 38.7 137.7 38.25 126L36 84.1495C36 83.2495 36.4501 82.7996 37.3501 82.7996H144C144.9 82.7996 145.35 83.2495 145.35 84.1495L143.1 126C143.1 137.7 133.65 146.7 122.4 146.7Z",
    fill: "url(#paint0_linear_4818_1676)",
    stroke: "#3C3636",
    strokeWidth: 6.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112.5L68 112.5",
    stroke: "#3C3636",
    strokeWidth: 6.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 112.5H141",
    stroke: "#3C3636",
    strokeWidth: 6.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8991 127.8C103.077 127.8 112.949 121.755 112.949 114.3C112.949 106.844 103.077 100.8 90.8991 100.8C78.7212 100.8 68.8491 106.844 68.8491 114.3C68.8491 121.755 78.7212 127.8 90.8991 127.8Z",
    fill: "white",
    stroke: "#3C3636",
    strokeWidth: 6.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.801 61.6499H45.9009V82L136.801 81.2501V61.6499Z",
    stroke: "#3C3636",
    strokeWidth: 6.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4009 72.4492H140.851",
    stroke: "#3C3636",
    strokeWidth: 6.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8012 61.65C55.8012 61.65 53.1012 39.15 77.4012 31.5C77.4012 31.5 87.7513 59.4 136.351 61.65",
    stroke: "#3C3636",
    strokeWidth: 6.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2998 44.1001C60.2998 44.1001 63.4499 49.9501 68.8499 51.3001",
    stroke: "#3C3636",
    strokeWidth: 6.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4818_1676",
    x1: 90.675,
    y1: 82.7996,
    x2: 90.675,
    y2: 146.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E06ABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9059E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecommendation);
export default __webpack_public_path__ + "static/media/no_recommendation.3495fe503c14d43644dffcc4e6dc2551.svg";
export { ForwardRef as ReactComponent };